<template>
  <div class="contact container-fluid">
    <div class="row">
      <Nav></Nav>

      <div class="col-sm-12" id="contacttext">
        <h6 style="font-family: 'Abril Fatface', cursive;">Phone (EN):
          <a href="tel:+66 830 318 750">+66 830 318 750</a>
        </h6>
        <h6 style="font-family: 'Abril Fatface', cursive;">Phone (TH):
          <a href="tel:+66 830 318 750">+66 873 360 699</a>
        </h6>
        <br>
        <h6 style="font-family: 'Abril Fatface', cursive;">Email:
          <a href="mailto:contact@rawproductions.asia">contact@rawproductions.asia</a>
        </h6>
        <br>
        <p style="font-family: 'Roboto', sans-serif;">
          RAW PRODUCTIONS CO., LTD.
          <br>
          ADDRESS: 10/175 (2202B) THE TRENDY BUILDING 22ND FLOOR,
          SUKHUMVIT SOI 13, KLONGTOEY NUA, WATTANA, BANGKOK, 10110, THAILAND
          <br>
          © 2019 RAW PRODUCTIONS CO., LTD.
        </p>
      </div>
    </div>
    <span id="codebirds">
      Created by <a href="https://codebirds.asia/" style="color: #75787B">codebirds.asia</a>
    </span>
  </div>
</template>


<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'

export default {
  name: 'contact',
  components: {
    Nav
  }
}
</script>
<style scoped>

.contact {
  background-size: cover;
  background-color: black;
  background-image: url("../../src/assets/Pages/CONTACTbig.gif");
  background-repeat: repeat;
  background-position: center;
  text-align: left;
  color: black;
  min-height: 100vh;
}

#contacttext {
  margin-top: 3rem;
  padding: 4rem 5rem 0rem 30rem;
}

#contacttext a {
  text-decoration: none;
  color: blue;
}

#contacttext h6 {
  font-size: 2rem;
}

#contacttext p {
  font-size: 1rem;
}

#codebirds {
  display: block;
  position: absolute;
  bottom: .5rem;
  right: .5rem;
  color: #75787B;
  font-family: 'Roboto', sans-serif;
  text-align: right;
}

@media (max-width: 1024px) and (orientation: portrait) {
  .contact {
    background-image: url("../../src/assets/newpages/What-we-do-Verticalsmall.gif");
    font-size: .75rem;
    color: white;
  }

  #contacttext {
    margin-top: 3rem;
    padding: 3rem;
  }
  #contacttext a {
    text-decoration: none;
    color: white;
  }
}

@media (max-width: 823px) and (orientation: landscape) {
  .contact {
    background-image: url("../../src/assets/newpages/Contact-us-desktop-small.gif");
    font-size: .75rem;
    color: white;
  }

  #contacttext {
    margin-top: 1rem;
    padding: 3rem;
  }

  #contacttext h6 {
    font-size: 1.2rem;
  }

  #contacttext p {
    font-size: .75rem;
  }

}

@media (max-width: 414px) {
  .contact {
    background-image: url("../../src/assets/newpages/What-we-do-Verticalsmall.gif");
    font-size: .75rem;
    color: white;
  }

  #contacttext {
    margin-top: 3rem;
    padding: 1rem;
  }

  #contacttext h6 {
    font-size: 1rem;
  }

  #contacttext p {
    font-size: .75rem;
  }

  #codebirds {
    display: none;
  }
}

</style>
